import Login from "@/components/views/Security/Login";

const Index = () => <Login />;

export default Index;
